// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3bi3o","search":"Settings_search__2TsN-","filter":"Settings_filter__1kHIY"};